import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoublesliderComponent } from './doubleslider.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        DoublesliderComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        DoublesliderComponent
    ]
})
export class DoublesliderModule { }
